export default {
  namespaced: true,
  state: {
    users: [],
    employees: [],
    userPermissions: [],
    count: 0,
    employeesCount: 0,
    userProfiles: [],
  },
  getters: {
    users: (state) => state.users,
    employees: (state) => state.employees,
    userPermissions: (state) => state.userPermissions,
    count: (state) => state.count,
    employeesCount: (state) => state.employeesCount,
    userProfiles: (state) => state.userProfiles,
  },
  mutations: {
    users: (state, payload) => (state.users = payload),
    employees: (state, payload) => (state.employees = payload),
    userPermissions: (state, payload) => (state.userPermissions = payload),
    count: (state, payload) => (state.count = payload),
    employeesCount: (state, payload) => (state.employeesCount = payload),
    userProfiles: (state, payload) => (state.userProfiles = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$authApiService
        .get("/list-users", {
          params: queryParams,
        })
        .then((res) => {
          commit("users", res?.data?.data ?? []);
          commit("count", res?.data?.count ?? []);
          return res;
        });
    },
    employees({ commit }, queryParams) {
      this.$authApiService
        .get("/list-users", {
          params:
            typeof queryParams === "object"
              ? { ...queryParams, type: "employee" }
              : { type: "employee" },
        })
        .then((res) => {
          commit("employees", res?.data?.data ?? []);
          commit("employeesCount", res?.data?.count ?? []);
          return res;
        });
    },
    show({}, queryParams) {
      return this.$authApiService.get("/list-user-by-id", {
        params: queryParams,
      });
    },
    create({}, payload) {
      return this.$authApiService.post("/create-user", payload);
    },
    update({}, data) {
      return this.$authApiService.post(`/update-user`, data);
    },
    sendMail({}, payload) {
      return this.$apiService.post(`/send-register-mail`, payload);
    },
    create({}, payload) {
      return this.$authApiService.post("/create-user", payload);
    },
    destroy({}, payload) {
      return this.$authApiService.post(`/delete-user`, payload);
    },
  },
};
